export function validateRichTextEditorContent(text: string | undefined) {
  return text !== "<p></p>" && text !== "<p><br></p>"; // TODO: Verify if has content
}
